<template>
    <!--編輯程式功能-->
    <v-card style="padding: 0px 10px;">

        <v-toolbar dark dense color="tertiary">
            <v-toolbar-title> {{formTitle}} </v-toolbar-title>

            <v-spacer></v-spacer>
            <v-btn title="關閉視窗" icon dark @click.native="closeDialog">
                <v-icon>mdi-close</v-icon>
            </v-btn>

        </v-toolbar>

        <v-card-text>
            <v-container grid-list-md  style="padding: 0px!important;">

                <v-layout wrap row xs12 sm12 md12>

                    <v-flex xs12 sm6 md4 d-inline-flex>

                        <v-flex xs1 sm1 md3 text-right  class="labelFont">
                            <v-label ></v-label>
                        </v-flex>

                        <v-flex xs11 sm11 md8 pl-2 text-center>
                            <v-radio-group  v-model="effFlag"  row hide-details >
                                <v-radio color="primary"  label="有效" value='Y' hide-details ></v-radio>
                                <v-radio color="primary" label="無效" value='N' hide-details ></v-radio>
                                <v-radio color="primary" label="使用者維護" value='U' hide-details ></v-radio>
                                <v-radio color="primary" label="系統維護" value='M' hide-details ></v-radio>
                            </v-radio-group>

                        </v-flex>
                    </v-flex>



                    <v-flex xs12 sm6 md4 d-inline-flex>
                        <v-flex xs5 sm5 md5 text-right  class="labelFont">
                            <v-label >顯示順序</v-label>
                        </v-flex>
                        <v-flex xs7 sm7 md7 pl-2>
                            <v-text-field  v-model="sortByNo"  type="number"  clearable></v-text-field>
                        </v-flex>
                    </v-flex>



                    <v-flex xs12 sm6 md4 d-inline-flex>
                        <v-flex xs5 sm5 md5 text-right  class="labelFont">
                            <v-label >系統代號</v-label>
                        </v-flex>
                        <v-flex xs7 sm7 md7 pl-2>
                            <!--<v-autocomplete-->
                                    <!--v-model="systemId"-->
                                    <!--hide-details-->
                                    <!--:items="this.systemIdList"-->
                                    <!--item-text="value"-->
                                    <!--item-value="key"-->
                            <!--&gt;</v-autocomplete>-->

                            <v-text-field   v-model="systemId"  ></v-text-field>

                        </v-flex>
                    </v-flex>




                    <v-flex xs12 sm6 md4 d-inline-flex>
                        <v-flex xs5 sm5 md5 text-right  class="labelFont">
                            <v-label >父層代號</v-label>
                        </v-flex>
                        <v-flex xs7 sm7 md7 pl-2>
                            <v-text-field   v-model="parentId"   clearable @keyup.enter="axios_getParentName(parentId)"></v-text-field>
                        </v-flex>
                    </v-flex>





                    <v-flex xs12 sm6 md4 d-inline-flex>
                        <v-flex xs5 sm5 md5 text-right  class="labelFont">
                            <v-label >父層名稱</v-label>
                        </v-flex>
                        <v-flex xs7 sm7 md7 pl-2>
                            <v-text-field   v-model="parentName"  disabled ></v-text-field>
                        </v-flex>
                    </v-flex>




                    <v-flex xs12 sm6 md4 d-inline-flex>
                        <v-flex xs5 sm5 md5 text-right  class="labelFont">
                            <v-label >功能圖標</v-label>
                        </v-flex>
                        <v-flex xs7 sm7 md7 pl-2 >
                            <img   :src="funIcon" id="image1" :class="[ funIcon!='' ? 'uerIcon' : 'noUerIcon']" ref="imgref" style="min-width: 40px;max-width: 40px; width: 40px;height: 40px;border: 1px solid gray">

                            <!-- pickPicPhoto('iptImage1','image1',25,25)-->
                            <input  class="custom-file-input" type="file" ref="fileref"  id="iptImage1" value="" @change="InputLoadImageToBindImageElement"  />

                            <v-btn  title="刪除圖標" icon  @click.native.stop="deleteImgIcon"><!---->
                                <v-icon  color="pink">mdi-delete</v-icon>
                            </v-btn>
                        </v-flex>
                    </v-flex>



                    <v-flex xs12 sm6 md4 d-inline-flex>
                        <v-flex xs5 sm5 md5 text-right  class="labelFont">
                            <v-label >功能代號</v-label>
                        </v-flex>
                        <v-flex xs7 sm7 md7 pl-2>
                            <v-text-field :disabled="this.editIndex!=-1"  v-model="funId"   clearable></v-text-field>
                        </v-flex>
                    </v-flex>




                    <v-flex xs12 sm6 md4 d-inline-flex>
                        <v-flex xs5 sm5 md5 text-right  class="labelFont">
                            <v-label >功能名稱</v-label>
                        </v-flex>
                        <v-flex xs7 sm7 md7 pl-2>
                            <v-text-field   v-model="funTitle"   clearable></v-text-field>
                        </v-flex>
                    </v-flex>


                    <v-flex xs12 sm6 md4 d-inline-flex>
                        <v-flex xs5 sm5 md5 text-right  class="labelFont">
                            <v-label >功能說明</v-label>
                        </v-flex>
                        <v-flex xs7 sm7 md7 pl-2>
                            <v-text-field   v-model="funMemo"  clearable></v-text-field>
                        </v-flex>
                    </v-flex>



                    <v-flex xs12 sm6 md4 d-inline-flex>
                        <v-flex xs5 sm5 md5 text-right  class="labelFont">
                            <v-label >功能URL</v-label>
                        </v-flex>
                        <v-flex xs7 sm7 md7 pl-2>
                            <v-text-field   v-model="funUrl"   clearable></v-text-field>
                        </v-flex>
                    </v-flex>




                    <v-flex xs12 sm6 md4 d-inline-flex>
                        <v-flex xs5 sm5 md5 text-right  class="labelFont">
                            <v-label >功能參數</v-label>
                        </v-flex>
                        <v-flex xs7 sm7 md7 pl-2>
                            <v-text-field   v-model="funParam"  clearable></v-text-field>
                        </v-flex>
                    </v-flex>

                    <v-flex xs12 sm6 md4 d-inline-flex>
                        <v-flex xs5 sm5 md5 text-right  class="labelFont">
                            <v-label >院區清單</v-label>
                        </v-flex>
                        <v-flex xs7 sm7 md7 pl-2>
                            <v-text-field   v-model="zoneList"  clearable></v-text-field>
                        </v-flex>
                    </v-flex>






                </v-layout>

            </v-container>
        </v-card-text>
        <v-card-actions style="margin-bottom: 10px;margin-right: 10px;">
            <v-spacer></v-spacer>
            <v-btn  @click.native="closeDialog">取消</v-btn>
            <v-btn  @click.native="save">送出</v-btn>
        </v-card-actions>



    </v-card>
</template>

<script>
    export default {
        name: "EditFunInfo",
        props:['editIndex','isShow','editObj','systemIdList'],
        data() {
            return {
                effFlag:'Y',
                systemId:'IREGSYS',//系統代號
                parentId:'',//父層代號
                parentName:'',//父層代號名稱
                funId:'',//功能代號
                funTitle:'',//功能名稱
                funMemo:'',//功能說明
                funUrl:'',//功能URL
                funParam:'',//功能參數
                zoneList:'',//院區清單 110/08/18 新增
                securityTypeList:'',//權限類別說明清單
                sortByNo:'',
                funIcon:'',
                modifyObj:{},
            }
        },
        watch:{
            isShow(val){
                if(val==true&this.editIndex!=-1){
                    this.effFlag = this.editObj.effFlag;
                    this.sortByNo = this.editObj.sortByNo==undefined?'':this.editObj.sortByNo;
                    // this.systemId=this.editObj.systemId==undefined?'':this.editObj.systemId,//系統代號
                        this.parentId=this.editObj.parentId==undefined?'':this.editObj.parentId,//父層代號
                        this.parentName='',//父層代號名稱
                        this.funId=this.editObj.funId==undefined?'':this.editObj.funId,//功能代號
                        this.funTitle=this.editObj.funTitle==undefined?'':this.editObj.funTitle,//功能名稱
                        this.funMemo=this.editObj.funMemo==undefined?'':this.editObj.funMemo,//功能說明
                        this.funUrl=this.editObj.funUrl==undefined?'':this.editObj.funUrl,//功能URL
                        this.funParam=this.editObj.funParam==undefined?'':this.editObj.funParam,//功能參數
                        this.sortByNo=this.editObj.sortByNo==undefined?'':this.editObj.sortByNo;
                    this.funIcon = this.editObj.funIcon==undefined?'':this.editObj.funIcon;
                    this.parentName = this.axios_getParentName(this.parentId);
                    this.zoneList = this.editObj.zoneList==undefined?'':this.editObj.zoneList;

                }else {
                    this.effFlag = 'Y';
                    this.sortByNo = '';
                    // this.systemId='',//系統代號
                        this.parentId='',//父層代號
                        this.parentName='',//父層代號名稱
                        this.funId='',//功能代號
                        this.funTitle='',//功能名稱
                        this.funMemo='',//功能說明
                        this.funUrl='',//功能URL
                        this.funParam='',//功能參數
                        this.securityTypeList='',//權限類別說明清單
                        this.sortByNo='';
                    this.funIcon = '';
                    this.zoneList = '';
                    let  img = document.getElementById('image1');
                    img.setAttribute('src', '');

                }

            },
        },
        computed:{
            formTitle () {
                return this.editIndex == -1 ? '新增 程式功能清單' : '編輯 程式功能清單'
            },
            loginUser() {
                return this.$store.state.loginUser;
            },
        },
        methods:{
            transSecType(securityType){
                let transResult = '';
                if(typeof securityType == "string"&&securityType !==''){
                    transResult =securityType==''?'':JSON.parse(securityType)
                }else if(typeof securityType == "object"){
                    transResult = securityType
                }else {
                    transResult = '';
                }
                // console.log(transResult);
                return transResult;
            },
            deleteImgIcon(){
                let  img = document.getElementById('image1');
                img.setAttribute('src', '');
            } ,
            InputLoadImageToBindImageElement(){
                let inputEl = document.getElementById('iptImage1');
                let imgEl = document.getElementById('image1');
                if (inputEl.files && inputEl.files[0]) {
                    let reader = new FileReader();
                    reader.onload = function (e) {
                        imgEl.setAttribute('src', e.target.result);
                    };
                    reader.readAsDataURL(inputEl.files[0]);
                    inputEl.value = ''; //重置了file的value
                }
            },
            pickPicPhoto(inputId,imgId,sizeW,sizeH){  //('iptImage1','image1',25,25)
                let inputFile = document.getElementById(inputId);
                let img = document.getElementById(imgId);

                //縮放圖片需要的canvas
                let canvas = document.createElement('canvas');
                let context = canvas.getContext('2d');

                // base64地址图片加载完毕后
                img.onload = function () {
                    // 图片原始尺寸
                    let originWidth = img.width;
                    let originHeight = img.height;
                    // 最大尺寸限制
                    let maxWidth = sizeW;
                    let maxHeight = sizeH;
                    // 目标尺寸
                    let targetWidth = originWidth;
                    let targetHeight = originHeight;
                    // 图片尺寸超过40x40的限制
                    if (originWidth > maxWidth || originHeight > maxHeight) {
                        if (originWidth / originHeight > maxWidth / maxHeight) {
                            // 更宽，按照宽度限定尺寸
                            targetWidth = maxWidth;
                            targetHeight = Math.round(maxWidth * (originHeight / originWidth));
                        } else {
                            targetHeight = maxHeight;
                            targetWidth = Math.round(maxHeight * (originWidth / originHeight));
                        }
                    }
                    // canvas对图片进行缩放
                    canvas.width = targetWidth;
                    canvas.height = targetHeight;
                    // 清除画布
                    context.clearRect(0, 0, targetWidth, targetHeight);


                    context.fillStyle = "#fff";
                    context.fillRect(0, 0, canvas.width, canvas.height);
                    // ctx.fillStyle = "rgba(255, 255, 255, 0.5)";
                    // ctx.globalAlpha = 0.5
                    // ctx.globalCompositeOperation = "lighter";

                    // context.fillRect(0, 0, canvas.width, canvas.height);

                    // 图片压缩
                    context.drawImage(img, 0, 0, targetWidth, targetHeight);
                    let data =  canvas.toDataURL("image/jpeg", 0.9);
                    img.setAttribute('src',data);

                };

                if (inputFile.files && inputFile.files[0]) {
                    let reader = new FileReader();
                    reader.onload = function (e) {
                        img.setAttribute('src', e.target.result);
                    };
                    reader.readAsDataURL(inputFile.files[0]);
                }

            },
            transformUTC(utc,flag){ //uct->Date ; flag-> all,date,time
                let date =  this.$UtilityJs.AD2ROC_DateTime(utc,flag);
                return (date)
            },
            closeDialog(){
                this.$emit('closeDialog');
            },
            save(){
                let  img = document.getElementById('image1');
                let imgsrc = img.getAttribute('src');
                if(this.funId==''){
                    alert('功能代號不能為空值')
                }else {

                    this.modifyObj = {
                        effFlag :  this.effFlag,
                        sortByNo: this.sortByNo==''||this.sortByNo==null?0:parseFloat(this.sortByNo).toFixed(1),
                        systemId:this.systemId,//系統代號
                        parentId:this.parentId,//父層代號
                        funId:this.funId,//功能代號
                        funTitle:this.funTitle,//功能名稱
                        funMemo:this.funMemo,//功能說明
                        funUrl:this.funUrl,//功能URL
                        funParam:this.funParam,//功能參數
                        securityTypeList:this.securityTypeList,//權限類別說明清單
                        zoneList:this.zoneList,//院區清單
                        funIcon : imgsrc,
                    };
                    this.$emit('save',this.modifyObj);
                }


            },
            axios_getParentName (funId){ //取得父層名稱
                if(funId!==''&&funId!==undefined&&funId!==null){
                    let url = '';
                    url = this.$store.state.AppSetting.backSrvUrl + "funlist/"+funId;
                    this.$http.get(url).then(response =>{
                        if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                            let data = response.data.resultSet[0];
                            this.parentName = data.funTitle
                        }else{
                            this.parentName = '';
                        }

                    }).catch(error =>  {
                        try {
                            console.log(error.response.data.status);
                            this.parentName = '';

                        } catch(err) {
                            this.parentName = '';
                        }
                    });
                }

            },
        }
    }
</script>

<style scoped>

    .custom-file-input {
        color: transparent;
        width: 100px;
        min-width: 100px;
        max-width: 100px;
        height: 36px;
        /*min-height: 30px;*/
        /*max-height: 30px;*/
        vertical-align: middle;
    }
    .custom-file-input::-webkit-file-upload-button {
        visibility: hidden;
    }
    .custom-file-input::before {
        letter-spacing: 0.1em;
        content: '+功能圖標';
        color: black;
        display: inline-block;
        background: -webkit-linear-gradient(top, #f9f9f9, #e3e3e3);
        border: 1px solid #999;
        border-radius: 15px;
        padding: 5px 8px;
        outline: none;
        white-space: nowrap;
        -webkit-user-select: none;
        cursor: pointer;
        text-shadow: 1px 1px #fff;
        font-weight: 700;
        /*font-size: 10pt;*/
    }
    .custom-file-input:hover::before {
        border-color: black;
    }
    .custom-file-input:active {
        outline: 0;
    }
    .custom-file-input:active::before {
        background: -webkit-linear-gradient(top, #e3e3e3, #f9f9f9);
    }


    .labelFont{
        line-height: 62px;
    }

</style>